<template>
  <div
    class="lv2-tags-selectes"
    :style="{ '--max-height': `calc(((100vh - ${top}px) * .75))` }"
  >
    <div class="lv2-tags-selectes-list-content">
      <div class="selects-wrap">
        <div class="side-bar">
          <ul>
            <li
              v-for="(tag, index) in tags"
              :key="index"
              :class="[
                +curTagIndex === index ? 'active' : '',
                selected[tag.type].length ? 'selected' : ''
              ]"
              ref="sideItem"
              @click="handleClickSideBar(index)"
            >
              {{ tag.title }}
            </li>
          </ul>
        </div>
        <div class="tags" ref="tags">
          <p class="title">{{ title }}</p>
          <div class="tag" v-for="(tag, index) in tags" :key="index" ref="tag">
            <p class="tag-name">
              {{ tag.title }}
              <span class="more" @click="tag.more = !tag.more"
                >{{ !tag.more ? '展开' : '收起' }}
                <i :class="['icon-arrow', !tag.more ? 'active' : '']" />
              </span>
            </p>
            <ul>
              <li
                v-for="(t, index) in tag.list.slice(
                  0,
                  !tag.more ? 9 : Infinity
                )"
                :class="[selected[t.type].includes(t.value) ? 'active' : '']"
                :key="index"
                @click="handleClickTag(t)"
              >
                {{ t.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="btns">
      <buttons
        :btns="[
          { label: '重置', onClick: reset, stat: '筛选重置按钮' },
          { label: '确定', onClick: submit, stat: '筛选确定按钮' }
        ]"
      />
    </div>
  </div>
</template>

<script>
import buttons from 'app/web/component/consult/listCommon/buttons.vue'
export default {
  components: { buttons },
  props: {
    value: {
      type: Object
    },
    list: {
      type: Array
    },
    top: {
      type: Number
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      selected: {},
      tags: [],
      curTagIndex: 0,
      stopScroll: false
    }
  },
  mounted() {
    this.$refs.tags.addEventListener('scroll', this._scrollHander)
    this.list.map(l => {
      const value = this.value[l.type]
      this.$set(this.selected, l.type, value && value.length ? value : [])
    })
    this.$watch(
      () => this.list,
      v => {
        const list = JSON.parse(JSON.stringify(v))
        this.tags = list.map(item => {
          item.more = false // 是否展开
          item.list = item.list.map(l => {
            const selected = this.selected[l.type].includes(l.value)
            l.selected = selected
            if (selected) item.more = true
            return l
          })
          return item
        })
      },
      { immediate: true }
    )
  },
  beforeDestroy() {
    this.$refs.tags.removeEventListener('scroll', this._scrollHander)
  },
  methods: {
    handleClickTag(tag) {
      const { type, value } = tag
      const selects = this.selected[type]
      const allIndex = selects.indexOf('all')
      const hasAll = allIndex > -1
      if (hasAll) this.$set(this.selected, type, []) // 有all清理all
      if (value === 'all' && !hasAll) return (this.selected[type] = ['all']) // 选中all
      const index = selects.indexOf(value)
      index > -1 ? selects.splice(index, 1) : this.selected[type].push(value)
    },
    // 侧边点击
    handleClickSideBar(index) {
      this.$refs.tag[index].scrollIntoView()
      this.$refs.sideItem[index].scrollIntoView()
      this.stopScroll = true
      this.curTagIndex = index
      setTimeout(() => (this.stopScroll = false), 500)
    },
    _scrollHander() {
      const tagsRefRectTop = this.$refs.tags
        .getBoundingClientRect()
        .top.toFixed()
      for (const i in this.$refs.tag) {
        const t = this.$refs.tag[i]
        const { top, bottom } = t.getBoundingClientRect()
        if (top <= +tagsRefRectTop && bottom >= +tagsRefRectTop) {
          this.stopScroll || (this.curTagIndex = i)
          this.$refs.sideItem[i].scrollIntoView()
          return
        }
      }
    },
    submit() {
      // const data = {
      //   'frontendKey-lv2Tags - 427': ['445', '444'],
      //   'frontendKey-lv2Tags - 452': ['2291'],
      //   'frontendKey-lv2Tags - 490': [],
      //   'frontendKey-hotKey': false
      // }
      this.$emit('change', {
        'frontendKey-hotKey': false,
        ...this.selected
      })
    },
    reset() {
      for (let key in this.selected) {
        this.selected[key] = []
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.lv2-tags-selectes {
  max-height: var(--max-height);
}
.lv2-tags-selectes-list-content {
  .selects-wrap {
    display: flex;
    .side-bar {
      width: 200px;
      background: #f2f4ff;
      ul {
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        max-height: calc(var(--max-height) - 1.44rem);
        li {
          position: relative;
          display: flex;
          align-items: center;
          width: 200px;
          height: 80px;
          padding-left: 32px;
          box-sizing: border-box;
          background: #f2f4ff;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #6c798c;
          flex-shrink: 0;
          &.active {
            color: #6982fa;
            background: #fff;
          }
          &.selected {
            &:after {
              position: absolute;
              right: 24px;
              display: inline-block;
              content: '';
              width: 8px;
              height: 8px;
              background: #6982fa;
              border-radius: 50%;
            }
          }
        }
      }
    }
    .tags {
      display: flex;
      flex-direction: column;
      padding: 0 32px;
      overflow-y: auto;
      max-height: calc(var(--max-height) - 1.44rem);
      padding-bottom: 0.4rem;
      box-sizing: border-box;
      .title {
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #9da3ac;
        margin-top: 20px;
        padding: 0;
        font-weight: 400;
      }
      .tag-name {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #21252d;
        margin: 30px 0 6px;
        padding: 0;
        .more {
          display: flex;
          align-items: center;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #6982fa;
          i {
            width: 14px;
            height: 14px;
            background: url(~images/common/icon-arrow-up.png) 100% / 100%
              no-repeat;
            margin-left: 8px;
            &.active {
              transform: rotate(180deg);
            }
          }
        }
      }
      ul {
        display: flex;
        align-items: cneter;
        flex-wrap: wrap;
        margin-bottom: 10px;
        li {
          width: 150px;
          height: 60px;
          background: #f3f4f5;
          border-radius: 10px;
          margin: 30px 18px 0 0;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #6c798c;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
          line-height: 0.8rem;
          padding: 0 10px;
          box-sizing: border-box;
          &:nth-of-type(3n) {
            margin-right: 0;
          }
          &.active {
            background: #6982fa;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
